//This method should be universal for calling API
//It simplifies try catch logic and error handling

import { all_endpoints } from './index'

export async function callApiAsync(methodName, body) {
    try {
        const method = all_endpoints[methodName]

        if (!method) {
            return { data: null, error: `Unknown method ${methodName}` }
        }

        const response = await method(body)

        const { data, status } = response

        //server returns custom errors in data object
        if (data.statuscode >= 400) {
            return { data: null, error: data.code }
        }

        return { data: response.data, error: null }
    } catch (error) {
        // BE custom error
        if (error.isBackendError) {
            return { data: null, error: error.code ?? error.statuscode }
        }

        // Axios/network error
        return { data: null, error }
    }
}
